export default __webpack_public_path__ + "static/media/IMG20210316211728 - 735_AMRUTANSHU DASH.076ccc7c.jpg";